<table >
  <tr style="height: 90px">
    <td rowspan="3" style="min-width: 15%">
      <div class="rotated-text">
        <p class="table-cell-title">Level of Operative</p>
      </div>
    </td>
    <td style="width: 35%">
      <!--*ngIf="operatives[0].operativeTypeId === '9e693556-8c16-44a2-b1e4-2c8d18b081ad'"-->
      <div class="table-cell-title" *ngIf="isHV">{{ getJobLevelWithIndex(4)?.name }} Operative </div>
      <div class="table-cell-title" *ngIf="!isHV">{{ getJobLevelWithIndex(1)?.name }} Operative </div>
      <div *ngIf="isHV"><em>({{ getJobLevelWithIndex(4)?.examples }})</em></div>
      <div *ngIf="!isHV"><em>({{ getJobLevelWithIndex(1)?.examples }})</em></div>
    </td>

    <td style="width: 16.6%;text-align: center" *ngIf="!isHV"
        [ngClass]="getMatrixClassFor(1,1)" >
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(1,1) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(1,1)"
                         [icon]="['fad',getIconNameInCell(1,1)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
    <td style="width: 16.6%;text-align: center" *ngIf="isHV"
        [ngClass]="getMatrixClassFor(4,4)" >
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(4,4) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(4,4)"
                         [icon]="['fad',getIconNameInCell(4,4)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>

    <td style="width: 16.6%;text-align: center" *ngIf="!isHV"
      [ngClass]="getMatrixClassFor(1,2)" >
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(1,2) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(1,2)"
                         [icon]="['fad',getIconNameInCell(1,2)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
    <td style="width: 16.6%;text-align: center" *ngIf="isHV"
      [ngClass]="getMatrixClassFor(4,5)" >
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(4,5) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(4,5)"
                         [icon]="['fad',getIconNameInCell(4,5)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>

    <td style="width: 16.6%;text-align: center" *ngIf="!isHV"
        [ngClass]="getMatrixClassFor(1,3)" >
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(1,3) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(1,3)"
                         [icon]="['fad',getIconNameInCell(1,3)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
    <td style="width: 16.6%;text-align: center" *ngIf="isHV"
        [ngClass]="getMatrixClassFor(4,6)" >
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(4,6) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(4,6)"
                         [icon]="['fad',getIconNameInCell(4,6)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
  </tr>
  <tr style="height: 90px">
    <td>
      <div class="table-cell-title" *ngIf="!isHV">{{ getJobLevelWithIndex(2)?.name }} Operative</div>
      <div class="table-cell-title" *ngIf="isHV">{{ getJobLevelWithIndex(5)?.name }} Operative </div>
      <div *ngIf="!isHV"><em>({{ getJobLevelWithIndex(2)?.examples }})</em></div>
      <div *ngIf="isHV"><em>({{ getJobLevelWithIndex(5)?.examples }})</em></div>
    </td>

    <td *ngIf="!isHV" [ngClass]="getMatrixClassFor(2,1)" style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(2,1) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(2,1)"
                         [icon]="['fad',getIconNameInCell(2,1)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
    <td *ngIf="isHV" [ngClass]="getMatrixClassFor(5,4)" style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(5,4) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(5,4)"
                         [icon]="['fad',getIconNameInCell(5,4)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>

    <td *ngIf="!isHV" [ngClass]="getMatrixClassFor(2,2)" style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(2,2) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(2,2)"
                         [icon]="['fad',getIconNameInCell(2,2)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
    <td *ngIf="isHV" [ngClass]="getMatrixClassFor(5,5)" style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(5,5) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(5,5)"
                         [icon]="['fad',getIconNameInCell(5,5)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>

    <td *ngIf="!isHV" [ngClass]="getMatrixClassFor(2,3)"  style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(2,3) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(2,3)"
                         [icon]="['fad',getIconNameInCell(2,3)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
    <td *ngIf="isHV" [ngClass]="getMatrixClassFor(5,6)"  style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(5,6) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(5,6)"
                         [icon]="['fad',getIconNameInCell(5,6)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
  </tr>
  <tr style="height: 90px">
    <td>
      <div class="table-cell-title" *ngIf="!isHV">{{ getJobLevelWithIndex(3)?.name }} Operative</div>
      <div class="table-cell-title" *ngIf="isHV">{{ getJobLevelWithIndex(6)?.name }} Operative </div>
      <div *ngIf="!isHV"><em>({{ getJobLevelWithIndex(3)?.examples }})</em></div>
      <div *ngIf="isHV"><em>({{ getJobLevelWithIndex(6)?.examples }})</em></div>
    </td>
    <td *ngIf="!isHV" [ngClass]="getMatrixClassFor(3,1)" style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(3,1) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(3,1)"
                         [icon]="['fad',getIconNameInCell(3,1)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
    <td *ngIf="isHV" [ngClass]="getMatrixClassFor(6,4)" style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(6,4) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(6,4)"
                         [icon]="['fad',getIconNameInCell(6,4)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>

    <td *ngIf="!isHV" [ngClass]="getMatrixClassFor(3,2)" style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(3,2) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(3,2)"
                         [icon]="['fad',getIconNameInCell(3,2)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
    <td *ngIf="isHV" [ngClass]="getMatrixClassFor(6,5)" style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(6,5) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(6,5)"
                         [icon]="['fad',getIconNameInCell(6,5)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>

    <td *ngIf="!isHV" [ngClass]="getMatrixClassFor(3,3)" style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(3,3) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(3,3)"
                         [icon]="['fad',getIconNameInCell(3,3)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
    <td *ngIf="isHV" [ngClass]="getMatrixClassFor(6,6)" style="text-align: center">
        <span class="risk-matrix-cell-count" *ngIf="operatives.length>1">{{ getOperativeNumbersInCell(6,6) }}</span>
        <fa-duotone-icon *ngIf="operatives.length === 1 && getIconNameInCell(6,6)"
                         [icon]="['fad',getIconNameInCell(6,6)]"
                         size="3x" primaryColor="white"></fa-duotone-icon>
    </td>
  </tr>
  <tr>
    <td colspan="2" style="border-left-color: transparent; border-bottom-color: transparent"></td>
    <td style="text-align: center" class="table-cell-title" *ngIf="!isHV">
      {{ getRiskWithIndex(1)?.name}} Risk
    </td>
    <td style="text-align: center" class="table-cell-title" *ngIf="!isHV">
      {{ getRiskWithIndex(2)?.name}} Risk
    </td>
    <td style="text-align: center" class="table-cell-title" *ngIf="!isHV">
      {{ getRiskWithIndex(3)?.name}} Risk
    </td>

    <td style="text-align: center" class="table-cell-title" *ngIf="isHV">
      {{ getRiskWithIndex(4)?.name}} Risk 
    </td>
    <td style="text-align: center" class="table-cell-title" *ngIf="isHV">
      {{ getRiskWithIndex(5)?.name}} Risk 
    </td>
    <td style="text-align: center" class="table-cell-title" *ngIf="isHV">
      {{ getRiskWithIndex(6)?.name}} Risk 
    </td>
  </tr>
  <tr>
    <td colspan="2" style="border-left-color: transparent; border-bottom-color: transparent"></td>
    <td colspan="3" style="text-align: center; width: 400px;">
      Degree of Risk in the Installation 
    </td>
  </tr>
</table>
